export default __webpack_public_path__ + "static/media/CHash3.b909e34f.mp3";